/**
 * Escopo "Todas" numa série (recorrência ou parcelamento): é a única operação que reescreve
 * ocorrência já concluída ("esta e futuras" preserva o que já se moveu). Antes de aplicar,
 * toda porta que oferece "Todas" com mudança de dinheiro — formulário de edição e sheet de
 * pagar — mostra o mesmo diálogo com a contagem. A regra é uma só, aqui, pra não voltar a
 * valer numa porta e não na outra (R5 do QA da 1.0.63: o formulário pulava o aviso quando a
 * única concluída era a própria linha editada; o sheet de pagar não avisava nunca).
 */
export type SeriesOccurrenceStats = { total: number; settled: number };

/**
 * Pede confirmação sempre que a série tem alguma ocorrência concluída — inclusive quando é
 * a própria linha que está sendo editada: "Todas" a partir dela reescreve a série inteira, e
 * quem reescreve dinheiro já pago precisa ver o aviso, não só quem edita a pendente.
 */
export function needsAllScopeConfirmation(
    stats: SeriesOccurrenceStats | null | undefined,
): stats is SeriesOccurrenceStats {
    return !!stats && stats.settled > 0;
}
